module.exports = __webpack_public_path__ + "static/media/IMG_0555.9ca38ce7.JPG";